/**
 * Action functions for pre-authorization operations.
 * These functions perform mutations on the sale state.
 */

/**
 * Removes inventory items from the sale.
 *
 * Reserved lines (layaway, special order, workorder) are detached and moved back to their tabs.
 * Non-reserved inventory lines are deleted from the sale.
 *
 * @param {Object} saleManager - The SaleManager instance
 * @param {number[]} saleLineIds - Array of sale line IDs to remove
 * @returns {Promise<void>} - Resolves when all lines are removed
 */
export function removeInventoryItems(saleManager, saleLineIds) {
  return new Promise((resolve, reject) => {
    window.doServerCall(
      {
        method: 'POST',
        form_name: 'register.generic',
        register_form: 'detach_inventory_lines_for_preauth',
        transaction_id: saleManager.sale.id,
        sale_line_ids: saleLineIds,
      },
      (result) => {
        if (result.success !== false) {
          resolve();
        } else {
          reject(new Error(result.error || 'Failed to remove inventory items'));
        }
      }
    );
  });
}
